// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerGlobal_container__Q273X"};